import React, { useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import Masonry, { ResponsiveMasonry } from "react-responsive-masonry";
import '../styles/Popular.css';
import { motion } from "framer-motion";
import { WeeklyContextMenu } from '../components/WeeklyContextMenu';
import { useData } from '../contexts/DataContext';

function Cuisine() {
  const { type } = useParams();
  const { recipes, weeklyMeals } = useData();

  const [filteredRecipes, setFilteredRecipes] = useState([]);
  const [contextMenu, setContextMenu] = useState(null);

  useEffect(() => {
    const normalizedType = type?.trim().toLowerCase();
    const results = recipes.filter((recipe) => {
      if (normalizedType === "healthy") return !!recipe.veryHealthy;
      // dishType-based categories (match URL param case-insensitively against dishTypes)
      //if (["Side Dish", "Sauce", "Sauces", "Dessert", "Dessert", "Bread", "Breakfast", "Main Course"].includes(normalizedType)) {
      //  return (recipe.dishTypes || []).some(d => d.trim().toLowerCase() === normalizedType);
      //}
      // everything else matches by cuisine
      return normalizedType && (recipe.cuisines || []).some(c => c.trim().toLowerCase() === normalizedType);
    });
    setFilteredRecipes(results.sort((a, b) => a.title.localeCompare(b.title)));
  }, [type, recipes]);

  const handleContextMenu = (e, recipe) => {
    e.preventDefault();
    setContextMenu({ x: e.clientX, y: e.clientY, recipe });
  };

  return (
    <motion.div animate={{ opacity: 1 }} initial={{ opacity: 0 }} exit={{ opacity: 0 }} transition={{ duration: 0.5 }}>
      {contextMenu && (
        <WeeklyContextMenu
          x={contextMenu.x}
          y={contextMenu.y}
          recipe={contextMenu.recipe}
          weeklyMeals={weeklyMeals}
          onClose={() => setContextMenu(null)}
        />
      )}

      <ResponsiveMasonry columnsCountBreakPoints={{ 350: 1, 750: 2, 900: 3, 1200: 4, 1500: 5 }}>
        <Masonry>
          {filteredRecipes.map((recipe) => (
            <div key={recipe.id} className="image-container" onContextMenu={(e) => handleContextMenu(e, recipe)}>
              <Link to={"/recipe/" + recipe.id}>
                <img height={"100%"} width={"100%"} src={recipe.image} alt={recipe.title}
                  style={{ display: "block", padding: "8px", borderRadius: "16px" }} />
              </Link>
              <div className="image-text">{recipe.title}</div>
            </div>
          ))}
        </Masonry>
      </ResponsiveMasonry>
    </motion.div>
  );
}

export default Cuisine;
